import React from 'react';
import { Step } from 'components/SteppedModal';
import useSocialShareModalFooter from 'containers/SocialShareModal/SocialShareModalFooter';
import { ThreadsSocialShareStep } from '../../types';
import ThreadsPostComposerStep from './ThreadsPostComposerStep';

export type UseThreadsPostComposerStepConfig = {
  onShare: () => void;
};

export default function useThreadsPostComposerStep({
  onShare,
}: UseThreadsPostComposerStepConfig): Step<ThreadsSocialShareStep> {
  const footerConfig = useSocialShareModalFooter({
    onShare,
  });

  return {
    ...footerConfig,
    id: 'composer',
    component: <ThreadsPostComposerStep />,
  };
}
